export default __webpack_public_path__ + "static/media/narinologo.61aa0a73.svg";